// Redux
import { Dispatch } from 'redux';
import { updatePostMessageRetry } from '@/redux/modules/post-message';
import { ReduxState } from '@/redux/modules/types';

// Types
import User from '@/types/user';
import { PostMessageOutgoingAction } from '@/enums/PostMessageAction';
import { ReducedPortfolioFDC3 } from '@/types/portfolio-fdc3';

export class PostMessageSender {
  static ready = (user: User | null | undefined, getState: () => ReduxState) => {
    const state = getState();
    postMessage(user, window.parent, PostMessageOutgoingAction.FACTSET_READY, undefined, state);
  };

  static getContactsAndPortfolios = (dispatch: Dispatch, getState: () => ReduxState, user: User | null | undefined) => {
    const state = getState();
    updatePostMessageRetry({ action: PostMessageOutgoingAction.FACTSET_GET_BOOK_OF_BUSINESS })(dispatch, getState, null);
    postMessage(user, window.parent, PostMessageOutgoingAction.FACTSET_GET_BOOK_OF_BUSINESS, undefined, state);
  };

  static getPortfolios = (dispatch: Dispatch, getState: () => ReduxState, user: User | null | undefined, reducedFDC3Portfolios: ReducedPortfolioFDC3[]) => {
    const state = getState();
    const context = { portfolios: reducedFDC3Portfolios };
    updatePostMessageRetry({ action: PostMessageOutgoingAction.FACTSET_GET_PORTFOLIOS, context })(dispatch, getState, null);
    postMessage(user, window.parent, PostMessageOutgoingAction.FACTSET_GET_PORTFOLIOS, context, state);
  };

  static openAccountLookup = (user: User | null | undefined, getState: () => ReduxState) => {
    const state = getState();
    postMessage(user, window.parent, PostMessageOutgoingAction.FACTSET_OPEN_ACCOUNT_LOOKUP, undefined, state);
  };
}

const postMessage = (
  user: User | null | undefined,
  targetWindow: Window,
  action: PostMessageOutgoingAction,
  context?: Record<string, unknown>,
  state?: ReduxState,
) => {
  if (!user) {
    return;
  }

  if (!state?.postMessage?.isPostMessageActive) {
    return;
  }

  console.log(`[POST_MESSAGE] Sending "${action}"`);

  const event = { action, context };

  targetWindow.postMessage(event, user.appConfig.postMessages.targetOrigin);
};
